import education from './education';
import workExperience from './workExperience';
import projectExperience from './proejctExperience';

const data = {
  body: {
    education:education,
    workExperience:workExperience,
    projectExperience:projectExperience,
  },
};
export default data;